import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  Plus, 
  Search, 
  Filter, 
  Edit, 
  Trash2, 
  Eye, 
  Building2,
  CreditCard,
  CheckCircle,
  XCircle,
  Star,
  StarOff,
  MapPin,
  Phone,
  Mail,
  Hash
} from 'lucide-react';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import { useAuth } from '../../contexts/AuthContext';
import { dataHelpers } from '../../lib/supabase';
import toast from 'react-hot-toast';

// Este arquivo foi removido do sistema porque a funcionalidade de banco não será mais utilizada.
export default function BanksPage() {
  return (
    <div className="p-8 text-center text-gray-500">
      <h1 className="text-2xl font-bold mb-4">Funcionalidade de bancos removida</h1>
      <p>O módulo de contas bancárias não está mais disponível neste sistema.</p>
    </div>
  );
}
